/**
 * File Accordion.js.
 */
/* eslint-disable */

const Accordion = () => {
    $('.acc__header').click(function(j) {
        const dropDown = $(this).closest('.acc__card').find('.acc__panel');
        $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
        
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.acc').find('.acc__header.active').removeClass('active');
            $(this).addClass('active');
        }
        
        dropDown.stop(false, true).slideToggle();
        j.preventDefault();
    });

    const activeHash = (function(){
        const location = window.location.hash;

        if(location) {
            $('' + location + '').find('.acc__header').addClass('active');
            $('' + location + '').find('.acc__panel').css('display', 'block');
        }
    })();
};

export default Accordion;


// WEBPACK FOOTER //
// ./scripts/components/Accordion.js